<template>  
<div> <!-- root element start -->
    <div class="container-fluid mt-2">

          <div class="row">
            <div class="col-sm-12 col-md-3">
                <div class="card border-0">
                  <div class="card-header h5 bg-transparent border-0">Options</div>
                  <div class="card-body">
                      <ul class="list-group list-group-flush">
                        <a href="#" class="list-group-item font-weight-bold" @click="changeRightView('user-org-list', '', '', '')">View Organization List</a>
                        <a href="#" class="list-group-item font-weight-bold" @click="changeRightView('create-org', '', '', '')">Create an Organization</a>
                      </ul>
                  </div>
                </div>
            </div>
            <div class="col-sm-12 col-md-9">
              <component 
                :is="rightView" 
                :prop1="prop1" 
                :prop2="prop2" 
                :prop3="prop3" 
                @onSComplete="successComplete" 
                @onUComplete="unsuccessComplete"
              >
              </component>
            </div>
           </div>

    </div><!--  end container-fluid div -->
</div> <!-- root element end -->
</template>


<script>
import {store} from '../../stores/user-org-main-store.js'

import userOrgList from '../userOrgPageComponents/user-org-list.vue'
import orgCreate from '../utilityComponents/orgComponents/org-create.vue'


export default {
  store,
  data: function () {
    return { 

    }
  },
  computed: {
    rightView () { return this.$store.state.rightView },
    prop1 () { return this.$store.state.prop1 },
    prop2 () { return this.$store.state.prop2 },
    prop3 () { return this.$store.state.prop3 },
  },
  watch: {
    
  },
  mounted() {
    this.getAllUserOrgs();
  },
  methods: {
    changeRightView(name, prop1, prop2, prop3) { this.$store.dispatch("getRightView", { name: name, prop1: prop1, prop2: prop2, prop3: prop3 }); },
    getAllUserOrgs() { this.$store.dispatch("getAllUserOrgs"); },
    
    successComplete(value) {
      var _this = this;
      switch(value[0]) {
        case 'org-add':
        _this.getAllUserOrgs();
        _this.changeRightView('user-org-list', '', '', '');
        break;

        default:
      }
    },
    unsuccessComplete(value) {
      var _this = this;
      switch(value[0]) {
        case 'org-add':
          _this.changeRightView('user-org-list', '', '', '');
        break;

        default:
      }
    },

  },    
  components:{
  	'user-org-list': userOrgList,
    'create-org': orgCreate,
  },
  filters: {

  }
}
</script>
